import React from 'react';
import './Conquista.css';

const etapas = [
  { titulo: 'Inscrição', descricao: 'AgroVacina inscrita no Desafio Liga Jovem, iniciativa nacional do Sebrae para negócios liderados por jovens.' },
  { titulo: 'Etapa Estadual', descricao: 'Selecionada entre os destaques do Maranhão para representar o estado na disputa nacional.' },
  { titulo: 'Semifinal Nacional', descricao: 'Avançamos à semifinal do desafio, competindo com startups de todo o Brasil.' }
];

const selos = [
  { icon: 'fas fa-trophy', texto: 'Semifinalista Nacional' },
  { icon: 'fas fa-map-marked-alt', texto: 'Representando o Maranhão' },
  { icon: 'fas fa-award', texto: 'Promovido pelo Sebrae' }
];

const Conquista = () => {
  return (
    <section id="conquista" className="section section-dark conquista">
      <div className="conquista-glow" aria-hidden="true"></div>
      <div className="container conquista-inner">
        <span className="section-eyebrow">Conquista</span>
        <h2 className="section-title">Semifinalistas do Desafio Liga Jovem Sebrae</h2>
        <p className="section-subtitle conquista-subtitle">
          A AgroVacina foi selecionada entre negócios jovens de todo o país e avançou até a semifinal do
          <strong> Desafio Liga Jovem</strong>, iniciativa nacional promovida pelo <strong>Sebrae</strong> para impulsionar o
          empreendedorismo jovem — representando o Maranhão nessa jornada.
        </p>

        <div className="conquista-grid">
          <div className="conquista-media">
            <img src="/assets/image/ligaJ.jpeg" alt="Equipe AgroVacina com a bandeira do Maranhão no Desafio Liga Jovem Sebrae" />
            <div className="conquista-media-badge">
              <i className="fas fa-trophy"></i>
              <span>Semifinal Nacional</span>
            </div>
          </div>

          <div className="conquista-card">
            <div className="conquista-selos">
              {selos.map((selo, index) => (
                <span key={index} className="pill">
                  <i className={selo.icon}></i>
                  {selo.texto}
                </span>
              ))}
            </div>

            <ol className="conquista-timeline">
              {etapas.map((etapa, index) => (
                <li key={index}>
                  <span className="conquista-timeline-step">{String(index + 1).padStart(2, '0')}</span>
                  <div>
                    <h4>{etapa.titulo}</h4>
                    <p>{etapa.descricao}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Conquista;
